jQuery(function($)
{
    var
        { hide } = orion,
        { show } = orion,
        $country = $('#home-country'),
        $shippingAddress = $('#shipping-address'),
        $shippingAddressDisabled = $('#shipping-address-disabled'),
        $shopCountryCodeMeta = $('meta[name=shop_country_code]'),
        $defaultShippingMode = $('[name=shippingMode][value=Billing]');

    if ($country.length === 0)
    {
        return;
    }

    function shopCountryCode()
    {
        if ($shopCountryCodeMeta.length == 0)
        {
            return false;
        }

        return $shopCountryCodeMeta.attr('content');
    }

    function shippingAddressShouldBeHidden(countryCode)
    {
        // tentative criterium, until we get better data for the decision
        var myShopCountryCode = shopCountryCode();

        return (typeof myShopCountryCode === 'string') && (myShopCountryCode.toLowerCase()
			!== countryCode.toLowerCase());
    }

    function resetShippingMode()
    {
        $defaultShippingMode.prop('checked', true);
    }

    function updateViewShippingAdress(countryCode)
    {
        if (shippingAddressShouldBeHidden(countryCode))
        {
            hide($shippingAddress);
            show($shippingAddressDisabled);
            resetShippingMode();
        }
        else
        {
            show($shippingAddress);
            hide($shippingAddressDisabled);
        }
    }

    function handleChange()
    {
        updateViewShippingAdress($(this).val()
            .toLowerCase());
    }

    updateViewShippingAdress($country.val().toLowerCase());

    $country.on('change', handleChange);
});
